export const EVENTS = Object.freeze({
  // Global & Session
  SESSION_STARTED: 'session_started',
  PAGE_VIEW: 'page_view',

  // Navigation & Redirection
  LOGIN_CLICKED: 'login_clicked',
  GET_STARTED_CLICKED: 'get_started_clicked',
  NAVBAR_BUTTON_CLICKED: 'navbar_button_clicked',
  STORE_LINK_CLICKED: 'store_link_clicked',
  TEACHERS_CHECKOUT_CLICKED: 'teachers_checkout_clicked',
  TEACHER_SITE_VISITED: 'teacher_site_visited',

  // Support & FAQ
  FAQ_SEARCHED: 'faq_searched',
  FAQ_CATEGORY_CHANGED: 'faq_category_changed',
  FAQ_EXPANDED: 'faq_expanded',
  SUPPORT_FORM_SUBMITTED: 'support_form_submitted',
  WHATSAPP_CONTACT_CLICKED: 'whatsapp_contact_clicked',

  // Pricing
  PRICING_PLAN_CLICKED: 'pricing_plan_clicked',
  PRICING_PAGE_VIEWED: 'pricing_page_viewed',

  // General
  FEATURE_USED: 'feature_used',
});


export const sessionStartedProps = ({ platform, appVersion }) => ({
  platform,
  app_version: appVersion,
});

export const pageViewProps = ({ path }) => ({
  page_path: path,
});

export const getStartedClickedProps = ({ location }) => ({
  location,
});

export const navbarButtonClickedProps = ({ buttonText, location }) => ({
  button_text: buttonText,
  location,
});

export const storeLinkClickedProps = ({ store, location }) => ({
  store,
  location,
});

export const faqSearchedProps = ({ query }) => ({
  query,
});

export const faqCategoryChangedProps = ({ category }) => ({
  category,
});

export const faqExpandedProps = ({ question }) => ({
  question,
});

export const supportFormSubmittedProps = ({ category, subject }) => ({
  category,
  subject,
});

export const pricingPlanClickedProps = ({ planName, price }) => ({
  plan_name: planName,
  price,
});

export const featureUsedProps = ({ featureName, context = {} }) => ({
  feature_name: featureName,
  ...context,
});

